import { useCallback } from 'react';
import FJAIStartLanding from './FJAIStartLanding';
import FJRecentFilesContainer from '../FJRecentFiles/FJRecentFiles.container';
import useLocalStore from '../../hooks/useLocalStore';
import { FJ_COMMON_VIEW } from '../../redux/slice/FJCommonSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { FJGeneratingPageAction } from '../../redux/action/FJGeneratingPageAction';
import { FJStartLandingAction } from '../../redux/action/FJStartLandingAction';
import FJGoogleDriveAction from '@src/redux/action/FJGoogleDriveAction.ts';
import FJYoutubeAction from '@src/redux/action/FJYoutubeAction.ts';
import { FJModalsAction } from '@src/redux/action/FJModalsAction';
import FJRequirementsUtil from '@src/util/FJRequirementsUtil';
import { getLtsUploadSource, setLtsUploadSource, LTS_SOURCE } from '@src/util/FJLongToShortEa';

export default function FJAIStartLandingContainer() {
    useLocalStore();
    const dispatch = useAppDispatch();
    const visible = useAppSelector(state => state.common.activeView === FJ_COMMON_VIEW.START_LANDING);
    const fileUrl = useAppSelector(state => state.startLanding.fileUrl);
    const projects = useAppSelector(state => state.startLanding.projects.items);
    const isVerifyingToGoogleDrive = useAppSelector(state => state.startLanding.isVerifyingToGoogleDrive);
    const bFLoading = useAppSelector(state => state.startLanding.bFLoading);

    const exitMultiSelect = useCallback(() => {
        dispatch(FJStartLandingAction.clearProjectSelectionAction());
    }, [dispatch]);

    const handleSubmitUrl = useCallback(
        (url: string) => {
            exitMultiSelect();
            setLtsUploadSource(LTS_SOURCE.YOUTUBE);
            FJRequirementsUtil.eaLog('long_to_shorts_vedio_upload', { source: getLtsUploadSource() });
            dispatch(FJYoutubeAction.submitYoutubeLinkAction(url));
        },
        [dispatch, exitMultiSelect],
    );

    const handleBrowseFile = useCallback(
        (file: File) => {
            exitMultiSelect();
            if (!FJRequirementsUtil.isLogin()) {
                FJRequirementsUtil.anonymousSignUp();
                return;
            }
            setLtsUploadSource(LTS_SOURCE.LOCAL_FILE);
            FJRequirementsUtil.eaLog('long_to_shorts_vedio_upload', { source: getLtsUploadSource() });
            dispatch(FJModalsAction.showLoadingModalAction('', () => {}, true));

            dispatch(FJGeneratingPageAction.setVideoMetaAction(file));
        },
        [dispatch, exitMultiSelect],
    );

    const handleFileUrlChange = useCallback(
        (value: string) => {
            dispatch(FJStartLandingAction.setYouTubeUrlAction(value));
        },
        [dispatch],
    );
    const handleGoogleDrive = useCallback(() => {
        exitMultiSelect();
        dispatch(FJGoogleDriveAction.authenticationGoogleDriveAction());
    }, [dispatch, exitMultiSelect]);

    if (!visible) {
        return null;
    }

    return (
        <FJAIStartLanding
            bFLoading={bFLoading}
            isVerifyingToGoogleDrive={isVerifyingToGoogleDrive}
            fileUrl={fileUrl}
            onFileUrlChange={handleFileUrlChange}
            onSubmitUrl={handleSubmitUrl}
            onBrowseFile={handleBrowseFile}
            onExitMultiSelect={exitMultiSelect}
            onGoogleDrive={handleGoogleDrive}
            belowFold={projects.length > 0 ? <FJRecentFilesContainer /> : undefined}
        />
    );
}
